import React from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './HowMathWorks.scss';

const HowMathWorks = () => (
  <section className="pl-how-math">
    <div className="pl-how-math__inner">
      <div className="pl-how-math__badge">
        <Badge variant="soft" color="info" size="sm">HOW THE MATH WORKS</Badge>
      </div>

      <h2 className="pl-how-math__title">
        Your rate × hours × trainers
      </h2>

      <div className="pl-how-math__formula">
        <div className="pl-how-math__box">
          <div className="pl-how-math__box-label">Base pay</div>
          <div className="pl-how-math__box-value">Rate × Hours × Trainers</div>
        </div>

        <div className="pl-how-math__operator">+</div>

        <div className="pl-how-math__box">
          <div className="pl-how-math__box-label">Go4 service fee</div>
          <div className="pl-how-math__box-value pl-how-math__box-value--accent">17.5%</div>
        </div>

        <div className="pl-how-math__operator">=</div>

        <div className="pl-how-math__box pl-how-math__box--total">
          <div className="pl-how-math__box-label">Total you pay</div>
          <div className="pl-how-math__box-value">Base + fee</div>
        </div>
      </div>

      <p className="pl-how-math__footnote">
        That's the whole model. There is no onboarding cost, placement premium,
        or annual platform fee underneath it.
      </p>
    </div>
  </section>
);

export default HowMathWorks;
